<template>
	<div>
		<!-- 弹窗模式 -->
		<el-dialog v-if="dialogMode && showDialog" :visible.sync="showDialog" width="80%" title="门店加工订单详情" append-to-body :close-on-click-modal="false" @close="closeDialog" class="store-detail-dialog">
			<div class="dialog-body-compact">
				<detail :detail-row="detailRow" :detail-type="detailType" :is-show-warehouse-qty="false"></detail>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button v-if="$checkBtnPermission('/order/index', 'cancelOrder') && orderType === 1 && state != 6 && state != 10" size="small" type="danger" @click="handleCancelOrder">取消订单</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 2" size="small" type="danger" @click="handleSubmitOrder">提交订单</el-button>
					<el-button
						v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 6 && (linkOrderKeyId === '' || linkOrderKeyId === null)"
						size="small"
						type="danger"
						@click="handleShowInnerDialog"
					>
						订单售后
					</el-button>
					<el-button size="small" @click="closeDialog">关闭</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 内联模式 -->
		<div v-if="!dialogMode && showDialog" class="inline-order-detail">
			<div class="inline-detail-header">
				<span class="inline-detail-title">门店加工订单详情</span>
				<el-button size="mini" icon="el-icon-close" @click="closeDialog">关闭</el-button>
			</div>
			<detail :detail-row="detailRow" :detail-type="detailType" :is-show-warehouse-qty="false"></detail>
			<div class="inline-detail-footer" v-if="showActions">
				<el-button v-if="$checkBtnPermission('/order/index', 'cancelOrder') && orderType === 1 && state != 6 && state != 10" size="small" type="danger" @click="handleCancelOrder">取消订单</el-button>
				<el-button v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 2" size="small" type="danger" @click="handleSubmitOrder">提交订单</el-button>
				<el-button
					v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 6 && (linkOrderKeyId === '' || linkOrderKeyId === null)"
					size="small"
					type="danger"
					@click="handleShowInnerDialog"
				>
					订单售后
				</el-button>
			</div>
		</div>

		<lcsj-dialog v-model="innerVisible" title="订单售后" width="45%" cancel-text="关闭" confirm-text="确认"
			 :close-on-click-modal="false"
			 append-to-body
			 :confirm-loading="isSubmitting" @confirm="handleAfterSaleOrder"> <el-form label-width="110px" size="small">
				<el-form-item label="原因类型：" required>
					<el-select v-model="afterSaleReasonType" placeholder="请选择售后原因类型" clearable filterable style="width: 100%" @change="handleReasonTypeChange">
						<el-option v-for="item in reasonTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="具体原因：" required>
					<el-select
						v-model="afterSaleReasonItem"
						:placeholder="afterSaleReasonType ? '请选择具体原因' : '请先选择售后原因类型'"
						clearable
						filterable
						style="width: 100%"
						:disabled="!afterSaleReasonType"
					>
						<el-option v-for="item in reasonItemList" :key="item.value" :label="item.value" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="原因说明：">
					<el-input v-model="afterSaleReason" placeholder="请输入原因说明（选填）" type="textarea" rows="4" maxlength="50" minlength="1" clearable show-word-limit></el-input>
				</el-form-item>
			</el-form></lcsj-dialog>
	</div>
</template>
<script>
import { CancelStoreOrder, SubmitStoreOrder, CreateAfterSaleOrder } from "@/api/storeOrderApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detail from "./detail.vue";

// 售后原因类型（责任方）：1 门店原因 / 2 加工原因，分别对应 EnumConfig 的两个根字典
const REASON_TYPE_DICT = [
	{ value: 1, label: "门店原因", code: "AfterSaleStoreReason" },
	{ value: 2, label: "加工原因", code: "AfterSaleProcessReason" }
];
// 字典未配置或接口异常时的兜底原因项，避免字典缺失阻断售后创建
const REASON_ITEM_FALLBACK = {
	1: ["新眼镜换镜架", "防控镜架涨度数售后"],
	2: ["镜片有划痕", "度数不对", "轴位不对"]
};
export default {
	props: {
		// 是否使用 el-dialog 弹窗模式（true=弹窗, false=列表下方内联展示）
		dialogMode: {
			type: Boolean,
			default: false
		},
		// 是否显示操作按钮（取消订单/提交订单/订单售后），顾客管理等纯查看场景传 false
		showActions: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDialog: false,
			keyId: "",
			state: 0,
			linkOrderKeyId: "",
			orderType: 1,
			innerVisible: false,
			afterSaleReasonType: "",
			afterSaleReasonItem: "",
			afterSaleReason: "",
			reasonTypeList: REASON_TYPE_DICT,
			reasonItemList: [],
			currentRow: null,
			detailRow: null,
			detailType: 1
		};
	},
	computed: {},
	components: {
		detail
	},
	created() {},
	methods: {
		// 显示
		showSeeDetailDialog(row, type = 1) {
			this.state = row.state;
			this.linkOrderKeyId = row.linkOrderKeyId;
			this.orderType = type;
			this.resetAfterSaleForm();
			this.keyId = row.keyId;
			this.detailType = type;
			this.showDialog = true;
			this.$nextTick(() => {
				this.detailRow = { ...row };
			});
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
		},
		// 取消订单
		handleCancelOrder() {
			this.$confirm("确定取消订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 调用取消订单接口
					CancelStoreOrder({
						keyId: this.keyId
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "取消订单成功"
								});
								this.closeDialog();
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消取消订单"
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消取消订单"
					});
				});
		},
		// 提交订单
		handleSubmitOrder() {
			this.$confirm("确定提交订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 调用提交订单接口
					SubmitStoreOrder({
						keyId: this.keyId
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "提交订单成功"
								});
								this.closeDialog();
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消提交订单"
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消提交订单"
					});
				});
		},
		// 创建售后订单
		handleAfterSaleOrder() {
			if (!this.afterSaleReasonType) {
				this.$message({
					type: "error",
					message: "请选择售后原因类型"
				});
				return;
			}
			if (!this.afterSaleReasonItem) {
				this.$message({
					type: "error",
					message: "请选择具体原因"
				});
				return;
			}
			this.$confirm("确定创建售后订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 调用订单售后接口
					CreateAfterSaleOrder({
						keyId: this.keyId,
						afterSaleReasonType: this.afterSaleReasonType,
						afterSaleReasonItem: this.afterSaleReasonItem,
						afterSaleReason: this.afterSaleReason
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "创建售后订单成功，售后订单号：" + res.data
								});
								this.resetAfterSaleForm();
								this.innerVisible = false;
								this.closeDialog();
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消订单售后"
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消订单售后"
					});
				});
		},
		// 售后原因类型切换：清空并重新加载该类型下的具体原因
		handleReasonTypeChange(val) {
			this.afterSaleReasonItem = "";
			this.reasonItemList = [];
			if (!val) {
				return;
			}
			const target = REASON_TYPE_DICT.find((item) => item.value === val);
			if (!target) {
				return;
			}
			GetEnumConfigListByCode({
				code: target.code
			})
				.then((res) => {
					if (res.code == 1 && res.data && res.data.length) {
						this.reasonItemList = res.data.map((item) => ({ value: item.name }));
					} else {
						this.reasonItemList = this.getFallbackReasonItems(val);
					}
				})
				.catch((err) => {
					this.reasonItemList = this.getFallbackReasonItems(val);
				});
		},
		// 兜底具体原因项（字典未配置或接口异常时使用）
		getFallbackReasonItems(val) {
			return (REASON_ITEM_FALLBACK[val] || []).map((name) => ({ value: name }));
		},
		// 重置售后表单
		resetAfterSaleForm() {
			this.afterSaleReasonType = "";
			this.afterSaleReasonItem = "";
			this.afterSaleReason = "";
			this.reasonItemList = [];
		},
		// 显示售后订单弹窗
		handleShowInnerDialog() {
			this.innerVisible = true;
			this.resetAfterSaleForm();
		}
	}
};
</script>
<style scoped lang="scss">
/* 弹窗模式下压缩 body 区域空白 */
.dialog-body-compact {
	margin: -10px 0 -15px 0;
}

.inline-order-detail {
	background: var(--app-surface);
	border: 1px solid var(--app-border);
	border-radius: 12px;
	padding: 16px 20px;
	margin-top: 16px;
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
}

.inline-detail-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 12px;
	padding-bottom: 10px;
	border-bottom: 1px solid var(--app-border-light);
}

.inline-detail-title {
	font-size: 16px;
	font-weight: 600;
	color: var(--app-text);
}

.inline-detail-footer {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	margin-top: 16px;
	padding-top: 12px;
	border-top: 1px solid var(--app-border-light);
}
</style>
